import React, { useState } from 'react';
import { Star, ShieldCheck, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function SocialProofSection() {
  return <div className="w-full bg-court-panel" data-id="element-272" data-mp="35pxdr18p352l">
      {/* SECTION 9 - TESTIMONIOS EXTENDIDOS */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-273" data-mp="30r40n9xblg2y">
        <div className="text-center mb-14" data-id="element-274" data-mp="30t6xacsza7gn">
          <h2 className="text-2xl sm:text-4xl font-heading font-extrabold text-white mb-4" data-id="element-275" data-mp="2d0zx12k4tgby">
            Lo que dicen los profesores
          </h2>
          <div className="flex items-center justify-center gap-2 text-xl font-heading font-bold text-white" data-id="element-276" data-mp="2849e87gy06mu">
            4.9/5
            <div className="flex text-yellow-400" data-id="element-277" data-mp="2i0m8b6gegmi4">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-278" data-mp="29ggkx610ijd" data-mpi={i} />)}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5" data-id="element-279" data-mp="3tgkkvkasdqo3">
          <TestimonialCard initials="MP" name="Martín P." city="Buenos Aires" quote="Compré un sábado. El domingo a la noche tenía el mes de clases listo. Nunca más improviso." data-id="element-280" data-mp="yfscby8jibqa" />
          <TestimonialCard initials="CG" name="Carolina G." city="Bogotá" quote="Tres alumnos de nivel inicial que estaban estancados mejoraron su posición en cancha en el primer mes con el Tomo 2." data-id="element-281" data-mp="18dycaaasd7si" />
          <TestimonialCard initials="FR" name="Federico R." city="Santiago" quote="Antes tardaba 1 hora armando la clase. Ahora abro el tomo, veo el drill y en 5 minutos entro a la cancha." data-id="element-282" data-mp="kncercyer5wr" />
          <TestimonialCard initials="SV" name="Sofía V." city="Ciudad de México" quote="El Nivelómetro me cambió la vida. Antes ubicaba a los alumnos a ojo. Ahora los clasifico en 5 minutos y mis grupos son mucho más parejos." data-id="element-283" data-mp="thh0jhyopr5f" />
          <TestimonialCard initials="DA" name="Diego A." city="Lima" quote="Los diagramas de cancha son un lujo. Los imprimo y los uso en la clase para mostrarle al alumno dónde tiene que estar. Se entiende todo de inmediato." data-id="element-284" data-mp="1497pxxrzg69a" />
          <TestimonialCard initials="LR" name="Laura R." city="Montevideo" quote="El Kit de Supervivencia me salvó dos veces este mes. Una vez que llegó un alumno nuevo sin aviso y otra que el encargado no dejó el depósito abierto." data-id="element-285" data-mp="192k57harv0pd" />
        </div>
      </section>

      {/* SECTION 10 - GARANTÍA */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-court-night border-y border-white/5" data-id="element-286" data-mp="qb12zcoknqoe">
        <div className="max-w-2xl mx-auto bg-white/[0.04] rounded-3xl border border-cyan-500/25 overflow-hidden" data-id="element-287" data-mp="25rrn8fc6mroj">
          <div className="p-8 text-center border-b border-white/[0.07]" data-id="element-288" data-mp="21qpn7wafybli">
            <div className="w-14 h-14 rounded-2xl bg-cyan-500/15 text-cyan-400 flex items-center justify-center mx-auto mb-5" data-id="element-289" data-mp="21sitvbl20vti">
              <ShieldCheck className="w-8 h-8" data-id="element-290" data-mp="2e9bk8chn7le7" />
            </div>
            <h2 className="text-2xl sm:text-3xl font-heading font-extrabold text-white" data-id="element-291" data-mp="2e6fkqjq5conn">
              Garantía 7 días sin preguntas
            </h2>
          </div>
          <div className="p-8 sm:p-10 text-center text-slate-300 leading-relaxed" data-id="element-292" data-mp="24bdwrr7lxsmn">
            <p className="mb-1.5" data-id="element-293" data-mp="2s186hzwmr12o">Abre los 12 Tomos.</p>
            <p className="mb-1.5" data-id="element-294" data-mp="2s2jde8ldgoy0">Revisa los 6 Bonus.</p>
            <p className="mb-6" data-id="element-295" data-mp="2wxyowtvwq8r9">Úsalos en tu próxima clase.</p>

            <p className="font-bold text-white mb-2" data-id="element-296" data-mp="2iax2kdcy4rvs">
              Si no es lo que esperabas →
            </p>
            <p className="text-cyan-400 font-heading font-extrabold text-2xl mb-6" data-id="element-297" data-mp="2n8osx2xy05xv">
              100% de devolución.
            </p>

            <p className="mb-8 text-slate-400" data-id="element-298" data-mp="3axq776tgibb2">
              Sin preguntas. Sin formularios. Sin drama.
            </p>

            <div className="inline-block bg-white/[0.06] border border-white/10 text-slate-400 font-bold px-5 py-2 rounded-full text-xs tracking-widest uppercase" data-id="element-299" data-mp="3frm3m4u2nq44">
              Tasa de devoluciones menor al 2%
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 11 - FAQ */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-300" data-mp="1i539xeuu13kl">
        <h2 className="text-2xl sm:text-4xl font-heading font-extrabold text-center text-white mb-12" data-id="element-301" data-mp="1d604htaxwvc3">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-3" data-id="element-302" data-mp="25sb697aa92ah">
          <AccordionItem question="¿Cómo recibo el material?" answer="Al completar el pago recibes un email con el acceso inmediato a todos los PDFs. En menos de 5 minutos ya puedes estar abriendo tu primer tomo. No hay espera. No hay envío físico." data-id="element-303" data-mp="25tctsb8hjh93" />
          <AccordionItem question="¿Sirve si soy profe nuevo o si tengo años de experiencia?" answer="Sí para los dos casos. Si eres nuevo: el sistema te da la estructura que no te enseñaron en el curso de profe. Si tienes experiencia: te ahorra las horas que pierdes planificando desde cero y le da un marco profesional a lo que ya sabes hacer." data-id="element-304" data-mp="2tjgti7ijywut" />
          <AccordionItem question="¿Qué incluye exactamente el acceso?" answer="Un solo pago de USD 27 te da acceso completo a los 12 Tomos y a los 6 Bonus estratégicos. No hay planes, ni niveles, ni suscripciones: todo el material está incluido desde el primer momento." data-id="element-305" data-mp="360rnwr81p4xz" />
          <AccordionItem question="¿Qué diferencia hay con otros materiales que ya existen?" answer="La mayoría de los materiales para profes de pádel son genéricos o están en inglés. PADEL 360 fue diseñado en español neutro y pensado para el contexto latinoamericano: la forma de enseñar, el vocabulario, los niveles de los clubes y los tipos de alumnos que tiene un profe en la región." data-id="element-306" data-mp="3jzr0h0ia9tds" />
          <AccordionItem question="¿Sirve para grupos con niveles mezclados?" answer="Sí. El Bonus 1 (Nivelómetro) fue diseñado exactamente para ese problema. Te permite clasificar a cada alumno en 5 minutos y asignarle el tomo correcto. El Bonus 5 (Kit de Supervivencia) tiene además el protocolo específico para manejar grupos mixtos sin aviso." data-id="element-307" data-mp="7jx3ywl7fynk" />
          <AccordionItem question="¿Qué pasa si no me sirve?" answer="Tienes 7 días de garantía total. Si abres el material y no es lo que esperabas, escríbenos y te devolvemos el 100% del dinero sin preguntas." data-id="element-308" data-mp="3iyyxlzu2c355" />
          <AccordionItem question="¿El precio es un pago único?" answer="Sí. Son USD 27 una sola vez, sin suscripciones ni cobros recurrentes. El acceso al material queda tuyo para siempre, incluidas las actualizaciones futuras." data-id="element-309" data-mp="ajxcaupf2ndu" />
          <AccordionItem question="¿Puedo pagar con tarjeta de crédito?" answer="Sí. Aceptamos todas las tarjetas de crédito y débito, además de transferencia bancaria y los medios de pago locales disponibles en tu país." data-id="element-310" data-mp="2cbtw0rlqn3jp" />
        </div>
      </section>
    </div>;
}
function TestimonialCard({
  initials,
  name,
  city,
  quote
}: {
  initials: string;
  name: string;
  city: string;
  quote: string;
}) {
  return <div className="bg-white/[0.03] rounded-2xl p-6 sm:p-7 border border-white/10" data-id="element-311" data-mp="i2wuwy520aw5">
      <div className="flex items-center gap-4 mb-5" data-id="element-312" data-mp="43otdylf4qos">
        <div className="w-11 h-11 rounded-full bg-cyan-500/15 text-cyan-400 flex items-center justify-center font-bold" data-id="element-313" data-mp="423y26ra53pv">
          {initials}
        </div>
        <div data-id="element-314" data-mp="3qb59on8whstd">
          <p className="font-bold text-white text-sm" data-id="element-315" data-mp="3qbor82un2f6v">{name}</p>
          <p className="text-xs text-slate-500 mt-0.5" data-id="element-316" data-mp="3qd837h99i42u">{city}</p>
        </div>
      </div>
      <div className="flex text-yellow-400 mb-4" data-id="element-317" data-mp="3vc2pwuacocs8">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-318" data-mp="1ohfn7m537cks" data-mpi={i} />)}
      </div>
      <p className="text-slate-300 leading-relaxed text-sm sm:text-base" data-id="element-319" data-mp="1ti3dg5lhrpdy">
        "{quote}"
      </p>
    </div>;
}
function AccordionItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-white/10 rounded-2xl bg-white/[0.03] overflow-hidden" data-id="element-320" data-mp="7incoraqumyn">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-5 sm:p-6 text-left focus:outline-none" data-id="element-321" data-mp="2kvkrxa3n0ug">
        <span className="font-bold text-white text-sm sm:text-base pr-4" data-id="element-322" data-mp="3toahnnco4gow">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-cyan-400 transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-323" data-mp="3kpyu5u73lz0o" />
      </button>
      <AnimatePresence data-id="element-324" data-mp="3fsqa1o2e3kws">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-325" data-mp="1iz5aauq2uvmv">
            <div className="px-5 sm:px-6 pb-6 text-slate-400 leading-relaxed text-sm sm:text-base border-t border-white/[0.07] pt-5" data-id="element-326" data-mp="1v8l6qjdg66s2">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}